import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import 'react-app-polyfill/stable';

import App from './containers/app';
import BitsyApollo from './services/BitsyApollo';
import IzootoServiceWorker from './services/IzootoServiceWorker';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

IzootoServiceWorker();

const BitsyCustomerFrontendApp = (
  <ApolloProvider client={BitsyApollo.client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>
);

render(BitsyCustomerFrontendApp, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
